import { createDraftSafeSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GlobalState } from '@store'
import { LoadingState, User } from '@types'

interface referralState {
  loadingStatus: LoadingState
  message: string
  referrals: User[]
}

const initialState: referralState = {
  loadingStatus: 'NOT_STARTED',
  message: '',
  referrals: []
}

export type referralAction = PayloadAction<User>

const referralSlice = createSlice({
  name: 'referral',
  initialState,

  reducers: {
    getReferrals: state => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    referralSuccess: (state, action: PayloadAction<User[]>) => {
      return {
        ...state,
        loadingStatus: 'SUCCESS',
        referrals: action.payload
      }
    },
    referralFailed: (state, action) => {
      return {
        ...state,
        loadingStatus: 'FAILED',
        message: action.payload
      }
    },
    clearreferral: _state => {
      return initialState
    }
  }
})

export const referralLoader = createDraftSafeSelector(
  [(state: GlobalState) => state.referral.loadingStatus, (state: GlobalState) => state.referral.message],
  (loadingStatus, message) => {
    const isLoading = loadingStatus === 'LOADING'
    const isFailed = loadingStatus === 'FAILED'
    const isSuccess = loadingStatus === 'SUCCESS'
    return { isLoading, isFailed, isSuccess, message }
  }
)

export const selectReferrals = createDraftSafeSelector(
  [(state: GlobalState) => state.referral.referrals],
  referrals => referrals
)

export const { getReferrals, referralSuccess, referralFailed, clearreferral } = referralSlice.actions
export default referralSlice.reducer
